export default __webpack_public_path__ + "static/media/alex_avatar.8e47fe29.jpg";